/* global axios */
import ApiClient from './ApiClient';

class CSATReportsAPI extends ApiClient {
  constructor() {
    super('csat_survey_responses', { accountScoped: true });
  }

  get({ page, from, to, agents, channels, teams, csats } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        since: from,
        until: to,
        agents: agents,
        channels: channels,
        teams: teams,
        csats: csats,
        sort: '-created_at',
      },
    });
  }

  getMetrics({ from, to, agents, channels, teams, csats } = {}) {
    return axios.get(`${this.url}/metrics`, {
      params: {
        since: from,
        until: to,
        agents: agents,
        channels: channels,
        teams: teams,
        csats: csats,
      },
    });
  }

  downloadReports(conditions) {
    return axios.get(`${this.url}/csat_export`, {
      params: { ...conditions, sort: '-created_at' },
    });
  }
}

export default new CSATReportsAPI();
